import Notifications from "./Notifications.vue";
import { CHAT_TOAST_QUEUE_MAX } from "@/helper/chatMemory";
function notificationDedupeKey(notification) {
    const chat = notification.chatContent;
    if (notification.isChatNoti && chat?.id != null) {
        return `chat:${chat.id}`;
    }
    if (notification.isChatNotiReaction && chat?.message?.id != null && chat?.user_reacted?.id != null) {
        return `reaction:${chat.message.id}:${chat.user_reacted.id}`;
    }
    const firebase = notification.firebaseNotiContent;
    if (notification.isFirebaseNoti && firebase?.id != null) {
        return `firebase:${firebase.type || 'unknown'}:${firebase.id}`;
    }
    return null;
}
const NotificationStore = {
    state: [],
    removeNotification(timestamp) {
        const indexToDelete = this.state.findIndex((n) => n.timestamp === timestamp);
        if (indexToDelete !== -1) {
            this.state.splice(indexToDelete, 1);
        }
    },
    addNotification(notification) {
        const dedupeKey = notification.dedupeKey || notificationDedupeKey(notification);
        if (dedupeKey) {
            const duplicate = this.state.some((item) => item.dedupeKey === dedupeKey);
            if (duplicate) {
                return;
            }
            notification.dedupeKey = dedupeKey;
        }
        notification.timestamp = new Date();
        notification.timestamp.setMilliseconds(notification.timestamp.getMilliseconds() + this.state.length);
        this.state.push(notification);
        while (this.state.length > CHAT_TOAST_QUEUE_MAX) {
            this.state.shift();
        }
    },
    notify(notification) {
        if (Array.isArray(notification)) {
            notification.forEach((notificationInstance) => {
                this.addNotification(notificationInstance);
            });
        }
        else {
            this.addNotification(notification);
        }
    },
};
const NotificationsPlugin = {
    install(Vue) {
        Vue.mixin({
            data() {
                return {
                    notificationStore: NotificationStore,
                };
            },
            methods: {
                notify(notification) {
                    NotificationStore.notify(notification);
                },
            },
        });
        Object.defineProperty(Vue.prototype, "$notify", {
            get() {
                return this.$root.notify;
            },
        });
        Object.defineProperty(Vue.prototype, "$notifications", {
            get() {
                return this.$root.notificationStore;
            },
        });
        Vue.component("Notifications", Notifications);
    },
};
export default NotificationsPlugin;
